import z from 'zod'
import { nullSafeOptionalString } from '../shared/schema'

export const schema = z.object({
  preMeeting: nullSafeOptionalString(),
  preMeetingClickWrapId: nullSafeOptionalString(),
})

export const empty = Object.freeze(schema.parse({}))

export type FirestoreSettingsTermsAndConditions = z.infer<typeof schema>
